import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const contactService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/contact/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/contact/' + id)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/contact/${id}`)
      return response.data
    },
}